
import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import {
  Box,
  ScrollBox,
  Inline,
  ContentBlock,
  Text,
} from "@64labs/bowline-design-system"

const ArticleFilterBar = ({ currentArticleCategory, location }) => {
  const [selectedArticleCategory, setSelectedArticleCategory] = useState(
    currentArticleCategory || null
  )
  const data = useStaticQuery(graphql`
    query {
      articleCategories: allContentfulArticleCategory {
        nodes {
          id
          name
        }
      }
    }
  `)

  console.log('Article categories:', data.articleCategories.nodes);
  return (
    <Box>
      <ContentBlock padding="none">
        <ScrollBox scrollX>
          <Box
            display="flex"
            style={{ height: 80 }}
            align="center"
            wrap={false}
          >
            <Text
              as={Link}
              to="articles"
              onClick={() => setSelectedArticleCategory("articles main")}
              tone={
                selectedArticleCategory === "articles main" ||
                location.pathname === "/articles/" ||
                location.pathname === "/articles"
                  ? "brandAccent"
                  : "neutral"
              }
              paddingLeft={"gutter"}
              style={{ whiteSpace: "nowrap" }}
            >
              articles main
            </Text>
            {data.articleCategories.nodes.map(({ name, id }, index) => {
              if (!name) return null;
              return (
                <Text
                  key={id || name}
                  as={Link}
                  to={`articles/${name.replace(/ /g, "-").toLowerCase()}`}
                  onClick={() => setSelectedArticleCategory(name)}
                  tone={
                    selectedArticleCategory === name ? "brandAccent" : "neutral"
                  }
                  paddingRight={["gutter", "gutter", "medium"]}
                  paddingLeft={
                    index === 0 ? ["gutter", "gutter", "medium"] : "none"
                  }
                  style={{ whiteSpace: "nowrap" }}
                >
                  {name}
                </Text>
              )
            })}
          </Box>
        </ScrollBox>
      </ContentBlock>
    </Box>
  )
}

export default ArticleFilterBar